module.exports = __webpack_public_path__ + "img/add-black-24dp.1f1eb316.svg";